import cx from 'classnames'
import { format } from 'date-fns'
import Highlight from 'react-highlighter'

import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'

import styles from './session.module.scss'
const DATETIME_FORMAT = 'MM/dd/yyyy HH:mm'

const matchStyle = {
  padding: '2px',
  backgroundColor: '#D9E8B2',
  borderRadius: '0.2rem'
}

function getTitleFromNode (nodes, index) {
  const node = nodes[index]

  if (Array.isArray(node?.children)) {
    const text = node?.children.map((c) => c.text).join('')
    if (text.trim().length > 0) {
      return text
    }
  }

  if (index === nodes.length - 1) {
    return null
  }

  return getTitleFromNode(nodes, index + 1)
}

function getTitle (note) {
  return getTitleFromNode(note.value.nodes, 0)
}

export function Session ({
  onClick,
  isActive,
  status,
  query,
  note
}) {
  const isDraft = note.draft === true
  const isModified = !!note?.diff ?? false

  return (
    <button
      type='button'
      className={cx('py-5 pl-6 pr-4 flex flex-col items-start overflow-hidden relative pointer transition-colors'
        , [ isDraft && styles.draft, isModified && styles.modified ])}
      style={{ backgroundColor: isActive ? '#EEF4FE' : 'transparent' }}
      onClick={onClick}
    >
      <div
        className={styles.dot}
        title={isDraft ? 'Draft' : 'Modified'}
      />

      <div
        className={styles.label}
        title={status?.description}
        style={{ backgroundColor: status?.color }}
      />

      <Highlight
        search={query}
        className={styles.preview}
        matchStyle={matchStyle}
      >
        {getTitle(note)?.trim() || 'Empty note'}
      </Highlight>

      <Footer
        name={note?.author?.name}
        updatedAt={note?.updated}
        createdAt={note?.created}
      />
    </button>
  )
}

function Footer ({ name, updatedAt, createdAt }) {
  const date = updatedAt ?? createdAt

  const createdAtString = createdAt ? format(new Date(createdAt), DATETIME_FORMAT) : null
  const updatedAtString = updatedAt ? format(new Date(updatedAt), DATETIME_FORMAT) : null

  let title = ''

  if (createdAtString) {
    title = `Created at ${createdAtString}`
  }

  if (updatedAt && createdAt) {
    title = title + '\n' + `Updated at ${updatedAtString}`
  }

  return (
    <span
      className={styles.datetime}
      title={title}
    >
      {name ?? ''}
      {date
        ? (
          <span>
            {' '}updated{' '}
            <FriendlyDateTime
              diff
              datetime={date}
            />
          </span>
        )
        : (
          <p>Not published yet</p>
        )}
    </span>
  )
}
